var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"hidden"}},[(_vm.options)?_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-default-skin",attrs:{"crossorigin":"use-credentials"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }